import css from './wordListFilters.module.scss';

import { memo } from 'react';

import { useBatchCreator, WithBatchCreator } from 'com/BatchCreator';
import { useWordEditor } from 'com/WordEditor';
import { useMessageModal } from 'core/ui/MessageModal';

import { TWordSearchFilters } from '../../../shared/types/domain';
import { AddWord, AddWords, SearchInput, SearchButton } from './Controls';
import SortMenu from './SortMenu';

type TProps = {
  fetchInitial: () => Promise<void>;
  deck: TDeck;
  addWord: (word: TWord) => void;
  filters: TWordSearchFilters;
  setFilter: <T extends keyof TWordSearchFilters>(
    key: T,
    value: TWordSearchFilters[T]
  ) => void;
};

const WordListFilters = ({
  deck,
  fetchInitial,
  addWord,
  filters,
  setFilter,
}: TProps) => {
  const { createWord } = useWordEditor();
  const { showError } = useMessageModal();
  const onAddClick = () =>
    createWord(deck.uid)
      .then(word => {
        if (word) addWord(word);
      })
      .catch(showError);
  const openAddWordsDialog = useBatchCreator();

  return (
    <form
      className={css.filters}
      onSubmit={evt => {
        evt.preventDefault();
        void fetchInitial();
      }}
    >
      <SearchInput
        value={filters.text}
        onChange={text => setFilter('text', text)}
      />
      <SearchButton onClick={() => void fetchInitial()} />
      <AddWord onClick={() => void onAddClick()} />
      <AddWords onClick={() => void openAddWordsDialog(deck)} />
      <SortMenu setFilter={setFilter} sort={filters.sort} />
    </form>
  );
};

export default WithBatchCreator(
  memo(WordListFilters) as typeof WordListFilters
);
